// initial state
const state = () => ({
    firstName: '',
    lastName: '',
    middleName: ''
})

// getters
const getters = {}

// actions
const actions = {
    addPersonalDetail ({ commit }, userPersonalDetails) {
        commit('setPersonalDetail', userPersonalDetails)
    }
}

// mutations
const mutations = {
    setPersonalDetail (state, personalDetail) {
        state.firstName = personalDetail.firstname,
        state.lastName = personalDetail.lastname,
        state.middleName = personalDetail.middleName
    },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}